module.exports = __webpack_public_path__ + "img/equity_inf_bg_img.eadc1017.png";